export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 1.3900000000000001,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "2": {
        "startTime": 12.09,
        "endTime": 13.55,
        "transcript": "Okay.",
        "translation": "Okay."
    },
    "3": {
        "startTime": 14.345,
        "endTime": 16.905,
        "transcript": "Ready? Okay.",
        "translation": "Ready? Okay."
    },
    "4": {
        "startTime": 17.39,
        "endTime": 22.09,
        "transcript": "Imguuq, Martha H. Jackson, Kuiggluk.",
        "translation": "Imguuq, Martha H. Jackson, Kwethluk."
    },
    "5": {
        "startTime": 23.445,
        "endTime": 25.685,
        "transcript": "Nunakenrilengramku.",
        "translation": "Even though I'm not originally from there."
    },
    "6": {
        "startTime": 26.37,
        "endTime": 27.93,
        "transcript": "Camiungusit nutem?",
        "translation": "Where are you originally from?"
    },
    "7": {
        "startTime": 28.945,
        "endTime": 32.1,
        "transcript": "Tuulkessaami born-allruunga.",
        "translation": "I was born in Tuluksak."
    },
    "8": {
        "startTime": 32.1,
        "endTime": 33.1,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "9": {
        "startTime": 37.855,
        "endTime": 49.175,
        "transcript": "Tua-ll' imkut-qaa ak'allaat yuut angullrunritaten qasgini uitalallret?",
        "translation": "So, were you born in time to see the people of old who lived in community houses?"
    },
    "10": {
        "startTime": 49.63,
        "endTime": 54.5,
        "transcript": "Anguyaaqekenka-w' tua-i tau͡gaam anguvlagluki.",
        "translation": "I was born in time to see them but just barely."
    },
    "11": {
        "startTime": 54.52,
        "endTime": 55.45,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "12": {
        "startTime": 55.46,
        "endTime": 57.36,
        "transcript": "Anguqamcagluki.",
        "translation": "I just barely born in time."
    },
    "13": {
        "startTime": 58.015,
        "endTime": 64.875,
        "transcript": "Anguyaaqekenka piciryaraat.",
        "translation": "I was born in time to see their practices."
    },
    "14": {
        "startTime": 67.43,
        "endTime": 76.0,
        "transcript": "Yuut-llu qantarluteng allakarmeng muraggaarnek waten nayuumalrianek.",
        "translation": "And people had their own separate bowls made of hollowed out wood like this."
    },
    "15": {
        "startTime": 78.01,
        "endTime": 80.89,
        "transcript": "Tua-i tamamta wangkuta qantarluta.",
        "translation": "We all had our own separate bowls."
    },
    "16": {
        "startTime": 80.895,
        "endTime": 93.235,
        "transcript": "Umyuarteq'lartua kinguani, \"Nallunge'rmeng yungcaristeńek makut piyuitellrullinilriit.\"",
        "translation": "I would think afterwards, \"Even though they didn't know about doctors, they didn't share bowls.\""
    },
    "17": {
        "startTime": 94.755,
        "endTime": 101.265,
        "transcript": "Nalamallma, nalarrlullma-w' man'a alungutma nalamalria man'a iqsulirneq.",
        "translation": "After my stroke, the left side of my tongue is paralyzed."
    },
    "18": {
        "startTime": 101.465,
        "endTime": 104.155,
        "transcript": "Ii-i. Canrituq. Taringnarquten.",
        "translation": "I see. It's okay. I can understand you."
    },
    "19": {
        "startTime": 104.645,
        "endTime": 107.395,
        "transcript": "Pillilrianga-w'. Taringnaqciqlilrianga.",
        "translation": "Probably. I may be understandable."
    },
    "20": {
        "startTime": 107.405,
        "endTime": 109.695,
        "transcript": "Ii-i, assirtuq. Assirtuq.",
        "translation": "Yes, it's good. It's good."
    },
    "21": {
        "startTime": 110.895,
        "endTime": 117.855,
        "transcript": "Tua-ll' makut yuut ilait qanruyutek'lallrit",
        "translation": "So, some of the traditional wisdom our people had"
    },
    "22": {
        "startTime": 118.22,
        "endTime": 129.41,
        "transcript": "Maa-i-rpak makunun ayagyuanun ikayuutngunayukluki niiculartukut.",
        "translation": "Now, we want to hear about them in case they help these young people."
    },
    "23": {
        "startTime": 129.71,
        "endTime": 134.02,
        "transcript": "Piciatun-qaa qanruyuterrarmek qanqeryuumiituten?",
        "translation": "Would you like to say any piece of traditional wisdom?"
    },
    "24": {
        "startTime": 134.61,
        "endTime": 147.59,
        "transcript": "Qanqackaryulrianga tau͡gaam wii murilkenrilngataullruunga ayagyuallemni.",
        "translation": "I would like to say something, but I wasn't observant when I was young."
    },
    "25": {
        "startTime": 149.045,
        "endTime": 160.025,
        "transcript": "Tua-i tupatallruunga tupaglua tua-i qanerturalriamun tua-i pek'artevkenii uitaurlua niicugniuralallruama.",
        "translation": "I would wake up to someone speaking because I would not move but stay still and listen."
    },
    "26": {
        "startTime": 161.64,
        "endTime": 165.86,
        "transcript": "Niicugniuralallruaqa qanertura'arqan.",
        "translation": "I would listen to them as they were speaking."
    },
    "27": {
        "startTime": 167.185,
        "endTime": 170.975,
        "transcript": "Makunek piciatun canek:",
        "translation": "These various things:"
    },
    "28": {
        "startTime": 171.005,
        "endTime": 183.355,
        "transcript": "Teglegyaramek, cali-llu qanrucunaunani arnaq, cali arnaq allakarmi angutetun ayuqenrilami",
        "translation": "Stealing, and a woman who does not listen to teaching, also because women were separate, different from the men"
    },
    "29": {
        "startTime": 184.225,
        "endTime": 192.285,
        "transcript": "Arnaq tau͡gaam elliin tua-i pilallermitun pitulliniuq.",
        "translation": "A woman instead does what she traditionally does."
    },
    "30": {
        "startTime": 195.65,
        "endTime": 212.136,
        "transcript": "Tua-ll' waten pitullruakut: \"Waniwa-gguq qanruyutmek niiquralaryaaqukut unuaquaqan kesianek atakuaqan-llu atakumi.\"",
        "translation": "And they would say this to us: \"We always hear about traditional wisdome every day, and during the evening.\""
    },
    "31": {
        "startTime": 213.017,
        "endTime": 220.272,
        "transcript": "Qanrutaqluta tua-i ayuqucirtuutnek qanrulluta.",
        "translation": "They would also tell us about instructions on how to be."
    },
    "32": {
        "startTime": 222.6,
        "endTime": 232.319,
        "transcript": "Maa-i-urluq makut kinguqliit qanrutestaitelalliameng-wa aanameggnek",
        "translation": "Because these poor descendats of ours probably are not taught by their mothers"
    },
    "33": {
        "startTime": 234.404,
        "endTime": 240.792,
        "transcript": "Tua-i atuqiit man'a, irniyaraq-ll' aturaqluku.",
        "translation": "They do unacceptable things, and they also have children out of wedlock."
    },
    "34": {
        "startTime": 241.618,
        "endTime": 246.672,
        "transcript": "Wiinga-ll' tutgaraagka malruk irniarlutek atailnguuk.",
        "translation": "And two of my grandchildren have illegitimate children."
    },
    "35": {
        "startTime": 250.017,
        "endTime": 258.153,
        "transcript": "Umyuarteq'lartua wiinga-wa alungutka neggluku qanrucuilamki",
        "translation": "I think that it's because I hold down my tongue and do not speak to them"
    },
    "36": {
        "startTime": 259.179,
        "endTime": 267.306,
        "transcript": "Qitevleqsugcuata-wa wangkucicetun qanerturpek'nateng.",
        "translation": "Because they speak English, not Yup'ik like us."
    },
    "37": {
        "startTime": 271.765,
        "endTime": 280.674,
        "transcript": "Tua-i qanruyun arnaq, arnani-ll' wangkuta waten piaqluta:",
        "translation": "The wisdom surrounding women, they would also tell us women this:"
    },
    "38": {
        "startTime": 280.684,
        "endTime": 292.093,
        "transcript": "\"Atam usuurluuq, waten ayuqellriaten. Tan'gaurlurmek-llu tangerquvet iqregken-llu taglutek.\"",
        "translation": "\"Look, dear one, you've grown this much. When you see a boy, your lips rise.\""
    },
    "39": {
        "startTime": 293.892,
        "endTime": 298.056,
        "transcript": "Quuyupitaraulluku-gguq tan'gaurluq.",
        "translation": "They said that she would give the boy a big smile."
    },
    "40": {
        "startTime": 299.532,
        "endTime": 310.058,
        "transcript": "Tua-i wii alik'lallruaqa. Imumek pilartut waten pairtellriani: \"Tamana atam quuyurniyuituq.\"",
        "translation": "I would fear that. They would do this when they passed each other: \"That one doesn't smile.\""
    },
    "41": {
        "startTime": 311.113,
        "endTime": 318.913,
        "transcript": "Pilallruatnga waten alingnaqliniami man'a.",
        "translation": "They would say this to me because it was scary."
    },
    "42": {
        "startTime": 318.919,
        "endTime": 322.837,
        "transcript": "Qanruyutet amlleqapiaryaaqut.",
        "translation": "There is actually a multitude of traditional wisdom."
    },
    "43": {
        "startTime": 323.212,
        "endTime": 335.245,
        "transcript": "Wangkuta tau͡gaam nalluyagulluki tuatiilamteki anerqeksaitaput makunun ayagyuanun, ukverngaicukluki-llu.",
        "translation": "But because we've forgotten them doing that, we don't bring them up with these young people, also thinking they won't believe them."
    },
    "44": {
        "startTime": 335.812,
        "endTime": 349.412,
        "transcript": "Waten makunek elitnaurluteng Kass'atun Yugtun cali qanruyutiit ukvekenritnayukluku wii maa-i umyuaqelalqa.",
        "translation": "Since they are educated in English, we don't think they will believe the traditional Yup'ik wisdom that I remember."
    },
    "45": {
        "startTime": 355.888,
        "endTime": 365.377,
        "transcript": "Ellaitnun tua-i, aren tua-i irniaqata kiaruciitnarqeqapiaralliniuq",
        "translation": "To them, my goodness, it's embarrassing when they have children out of wedlock"
    },
    "46": {
        "startTime": 366.58,
        "endTime": 372.59,
        "transcript": "Camek kegginirluta pillerkarput.",
        "translation": "What kind of face we should put on."
    },
    "47": {
        "startTime": 375.267,
        "endTime": 387.177,
        "transcript": "Makut-llu tan'gaurluut pairtaqamteki tungiinek anuqli'rqan umyuarteqaqluta waten:",
        "translation": "And when we're going to pass these boys and the wind is blowing from their side, we would think this:"
    },
    "48": {
        "startTime": 388.017,
        "endTime": 392.057,
        "transcript": "\"Naw'un-kiq wii kiturniarcia ukna?\"",
        "translation": "\"I which way I should pass him?\""
    },
    "49": {
        "startTime": 395.434,
        "endTime": 406.954,
        "transcript": "Tua-i uq'lirnerakun kitula'rqa qanruyuteka-w' tua-i taman' umyuaqluku, qanruyutelqa.",
        "translation": "I would pass him on the downwind side, remembering the traditional wisdom passed down to me."
    },
    "50": {
        "startTime": 408.149,
        "endTime": 420.229,
        "transcript": "Ca tua-i tamalkuan qanruyutekaat teglegyaraq-llu, yuum-llu nalluani camek pianek tegulluta nerrlerkarput.",
        "translation": "They had traditional wisdom for everything including stealing, and taking something from another person and eating it."
    },
    "51": {
        "startTime": 421.054,
        "endTime": 423.724,
        "transcript": "Tua-i-gguq teglegluta.",
        "translation": "That said that we were stealing."
    },
    "52": {
        "startTime": 426.064,
        "endTime": 428.294,
        "transcript": "Alingnaqluni.",
        "translation": "It is dangerous."
    },
    "53": {
        "startTime": 433.2,
        "endTime": 441.36,
        "transcript": "Qaillun tuani tua-i-wa niiteqerli.",
        "translation": "May he hear of it somehow."
    },
    "54": {
        "startTime": 441.365,
        "endTime": 453.345,
        "transcript": "Makut maa-i ayagyuat ilait tan'gaurluyagaat-llu makut aanait imumek mer'aluteng pilriit qaill' elli'irtelartut.",
        "translation": "Some of the young people here and the boys who drink become different."
    },
    "55": {
        "startTime": 453.62,
        "endTime": 455.78,
        "transcript": "Teglegyugluteng.",
        "translation": "They tend to steal."
    },
    "56": {
        "startTime": 456.765,
        "endTime": 463.925,
        "transcript": "Tuaten tua-i tamana ciunguluku qanrut'lalliniitkut wangkuta.",
        "translation": "That is the first reason that they tell us."
    },
    "57": {
        "startTime": 469.95,
        "endTime": 478.96,
        "transcript": "Qanrut'laryaaqelliniitkut tau͡gaam wangkuta tayim' nalluyagutaqluku eneqeraqluku.",
        "translation": "They would tell us, but we would forget it then remember it."
    },
    "58": {
        "startTime": 480.19,
        "endTime": 483.18,
        "transcript": "Umyuamteńun tut'aqluni.",
        "translation": "It would come up in our minds."
    },
    "59": {
        "startTime": 488.64,
        "endTime": 490.34,
        "transcript": "Tua-i-w' nangllill' qaa?",
        "translation": "That's all, right?"
    },
    "60": {
        "startTime": 490.465,
        "endTime": 491.345,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "61": {
        "startTime": 494.57,
        "endTime": 503.25,
        "transcript": "Man'a-qaa Yugcetun qalarcaraput, waten tua-i qalartellriakuk waniwa Yugcetun",
        "translation": "Is our Yup'ik language, the way we are speaking in Yup'ik now"
    },
    "62": {
        "startTime": 503.255,
        "endTime": 509.785,
        "transcript": "Man'a-qaa mat'um nalliini cagmarnarqenrituq, ciin-llu?",
        "translation": "Should we not lose it today, and why?"
    },
    "63": {
        "startTime": 511.485,
        "endTime": 522.475,
        "transcript": "Naamell'. Ellaita-wa tang imutun ilait-llu niipaalugnganateng irr'ituut.",
        "translation": "I don't know. Some of them are also amazed as if hearing it for the first time."
    },
    "64": {
        "startTime": 525.325,
        "endTime": 527.185,
        "transcript": "Tua-i tangvagluta.",
        "translation": "They watch us."
    },
    "65": {
        "startTime": 527.26,
        "endTime": 532.91,
        "transcript": "Tuaten piluta assikellruitkut tamakut qanrucilriit.",
        "translation": "The instructors would like it when we did that."
    },
    "66": {
        "startTime": 533.68,
        "endTime": 541.35,
        "transcript": "Qanra-ll' uluqsaunaku tangvagluku. Kiavet-gguq ircaqumteńun [ngelgar]tengnaqluku.",
        "translation": "And watch him without looking away from his mouth. They said to try to [set it] into our hearts."
    },
    "67": {
        "startTime": 543.05,
        "endTime": 552.21,
        "transcript": "Aren, maa-i wiinga'urluq cakegtaunrilama, makut-ll' irnianka qanrucunailnguut.",
        "translation": "Oh pity me, I am not a good person, and my children do not listen to instruction."
    },
    "68": {
        "startTime": 553.085,
        "endTime": 559.585,
        "transcript": "Arenqiatuq qanelput ellmikuunganani man'a inerquun.",
        "translation": "It's unfortunate that the admonishments we speak of seem to be for naught."
    },
    "69": {
        "startTime": 560.47,
        "endTime": 568.49,
        "transcript": "Inerquuteklerput wangkuta alikellerput ellmikuunganani ellaitni.",
        "translation": "The admonishments that we feared seem to be of no importance to them."
    },
    "70": {
        "startTime": 571.315,
        "endTime": 577.575,
        "transcript": "Man'a tau͡gaam tua-i qanruyutiitni",
        "translation": "But this, among the traditional wisdom passed down to them"
    },
    "71": {
        "startTime": 579.78,
        "endTime": 586.14,
        "transcript": "Qanruyutmek avalingqerquni ciumuruskuniu atawaugarkauguq.",
        "translation": "If one keeps the traditional wisdom with him and goes forth with it, he will do well."
    },
    "72": {
        "startTime": 589.425,
        "endTime": 601.975,
        "transcript": "Tua-i wiinga'urluq wani elluarrlua-ll' qallacetenritaanga mat'um, mat'um-w' ingluma nalarrlulriim tapeqnganga.",
        "translation": "Because I have a paralyzed side of my tongue, it keeps me from speaking well."
    },
    "73": {
        "startTime": 602.115,
        "endTime": 608.035,
        "transcript": "Waten iliini tapqevsiarngat'laraa, tau͡gaam taringnarqua.",
        "translation": "It seems to affect me more like this, but I am understandable."
    },
    "74": {
        "startTime": 609.682,
        "endTime": 616.574,
        "transcript": "Tua-ll' ak'a tamaani agayuviit maavet tekiteqarraallratni",
        "translation": "Then back when the churches first came here"
    },
    "75": {
        "startTime": 616.78,
        "endTime": 623.97,
        "transcript": "Yuut-llu niitengllermegteggu man'a Qaneryaraq agayuvigtaq",
        "translation": "And when people started hearing about the church's Bible"
    },
    "76": {
        "startTime": 624.357,
        "endTime": 634.357,
        "transcript": "Maaten niitaat allaussiyaagpek'nani Yuut qanruyutellricetun. (Ii-i.)",
        "translation": "They heard it and found that it was not too different from Yup'ik wisdom. (Yes.)"
    },
    "77": {
        "startTime": 634.383,
        "endTime": 636.123,
        "transcript": "Tamana-qaa piciuguq?",
        "translation": "Is that true?"
    },
    "78": {
        "startTime": 636.131,
        "endTime": 643.721,
        "transcript": "Piciuguq. Piciuyaaquq tau͡gaam wangkuta arenqiatuq atunrilamteńi",
        "translation": "It's true. It is true, but it's unfortunate that we do not adhere to them"
    },
    "79": {
        "startTime": 645.239,
        "endTime": 652.284,
        "transcript": "Atunrilamteńi, makunek-ll' irniamteńek piluta pilaamta.",
        "translation": "Because we don't adhere to them, and we do not teach them to our children."
    },
    "80": {
        "startTime": 654.338,
        "endTime": 661.71,
        "transcript": "Ilait tua-i... quyalartua. Ing'umek quyalartua Lagilegmek.",
        "translation": "Some of them... I am grateful. I am grateful for Lagilek over there."
    },
    "81": {
        "startTime": 667.363,
        "endTime": 669.091,
        "transcript": "Carrie-mek-wa.",
        "translation": "For Carrie."
    },
    "82": {
        "startTime": 670.674,
        "endTime": 677.125,
        "transcript": "Qanruyutni ak'a uum aturciqaa.",
        "translation": "She would adhere to the traditional wisdom passed down to her long ago."
    },
    "83": {
        "startTime": 677.132,
        "endTime": 684.05,
        "transcript": "Umyuarteqaqlua, \"Nauwa-m' murilkeksailngat'lartuq qalarutellriani.\"",
        "translation": "I would think, \"Wasn't she inattentive when being taught?\""
    },
    "84": {
        "startTime": 687.361,
        "endTime": 691.906,
        "transcript": "Tua-i ilii qemagcituami ircaquminun.",
        "translation": "It's because some people keep them in their hearts."
    },
    "85": {
        "startTime": 692.848,
        "endTime": 700.852,
        "transcript": "Ilumun piciuluni qanrut'lalliniitkut.",
        "translation": "They would tell us that it is true."
    },
    "86": {
        "startTime": 704.61,
        "endTime": 709.428,
        "transcript": "Mat'um-qaa nalliini nukalpiat enurnariut?",
        "translation": "Are there few great hunters these days?"
    },
    "87": {
        "startTime": 711.559,
        "endTime": 716.859,
        "transcript": "Arenqiatuq nukalpiaruciitut makut.",
        "translation": "It's unfortunate that these people don't know anything about being great hunters."
    },
    "88": {
        "startTime": 717.529,
        "endTime": 724.847,
        "transcript": "Imkut kitutulriit-llu paircamceteng-llu kan'a-ll' tangerrluku ayagluteng kiturluta.",
        "translation": "And when we're going to encounter those who pass by, they would look down and pass by us."
    },
    "89": {
        "startTime": 733.284,
        "endTime": 741.766,
        "transcript": "Maa-i imum au͡g'um qanellma ilakaa man'a, ilakellinia.",
        "translation": "This is part of what I just said."
    },
    "90": {
        "startTime": 746.963,
        "endTime": 756.081,
        "transcript": "Yuut-qaa nutem ak'a tamaakenirnek ilaliuqtallruut?",
        "translation": "Did people have ancient social interactions since ancient times?"
    },
    "91": {
        "startTime": 757.729,
        "endTime": 767.956,
        "transcript": "Ilaliuqtarngatellruut imkut. Allaneq-llu tekican tua-i kelegtuurluku maani Kuigglugmun elliumarilua.",
        "translation": "They seemed to have social interactions. And when a guest came, they would always invite him to eat when I had moved here to Kwethluk."
    },
    "92": {
        "startTime": 768.578,
        "endTime": 782.328,
        "transcript": "Imna alqairutka Qaltayak unguvallermini pilallra maa-i umyuaqaqa.",
        "translation": "I remember what my late older sister Qaltayak used to do"
    },
    "93": {
        "startTime": 790.309,
        "endTime": 801.954,
        "transcript": "Qanrut'lallrullikait-llu-wa allanret nunanun ayalriani caperrnarqelartuq yugnek nallulrianek.",
        "translation": "They would probably also talk about how hard it is for guests to go to villages where they don't know anyone."
    },
    "94": {
        "startTime": 802.221,
        "endTime": 809.632,
        "transcript": "Qanruyutek'lallrullikiit-wa ilaliulaasqelluki allanret.",
        "translation": "They would also probably tell them to be sociable with guests."
    },
    "95": {
        "startTime": 809.943,
        "endTime": 812.888,
        "transcript": "Tuaten tua-i qanrut'lallruitkut.",
        "translation": "That's what they would tell us."
    },
    "96": {
        "startTime": 813.532,
        "endTime": 820.232,
        "transcript": "Ilaliuqetailngut-gguq tungelqurrituq. Camek ilaituq.",
        "translation": "They say that an unsociable person has no close friends. He has no relatives."
    },
    "97": {
        "startTime": 822.41,
        "endTime": 836.532,
        "transcript": "Tau͡gken tua-i waten qanmikun wall' inerquqerluku-ll' taurrarmek piqallrulria tua-i ung'aqerrnganani ilii pilartuq, ungavik'ngarrluni.",
        "translation": "However, a person who is spoken to or given a small admonishment seems to respond affectionately, as if he were treated with affection."
    },
    "98": {
        "startTime": 841.587,
        "endTime": 848.087,
        "transcript": "Agurraq-ll' amllertuq inerquukar.",
        "translation": "Even a little admonishment such as \"Don't do that\" is enough."
    },
    "99": {
        "startTime": 850.676,
        "endTime": 861.221,
        "transcript": "Elpeni-qaa makut erenret nalliitni makut ayagyuat akusrarnerurtut?",
        "translation": "To you, have the young people these days become mischievous?"
    },
    "100": {
        "startTime": 862.421,
        "endTime": 866.988,
        "transcript": "Tuar tang umyugairutellriit maa-i.",
        "translation": "It seems they now lack common sense."
    },
    "101": {
        "startTime": 867.599,
        "endTime": 873.176,
        "transcript": "Camek tau͡gaam ellaita anglanillerkameggnek umyuangqerrnganateng.",
        "translation": "They only seem to think about what kind of fun they can have."
    },
    "102": {
        "startTime": 875.354,
        "endTime": 879.321,
        "transcript": "Imkut nauw' qigcigtallrulriit yugnun.",
        "translation": "In contrast, they would be respectful to people before."
    },
    "103": {
        "startTime": 879.332,
        "endTime": 886.254,
        "transcript": "Tua-i camek ikamrarluni-llu piami camek nalkucami ek'arrluku.",
        "translation": "When a person was traveling with a sled and found something, he would put it in."
    },
    "104": {
        "startTime": 886.599,
        "endTime": 894.043,
        "transcript": "Tua-i tekicami nerurarraarluni taqngami imna teguluku anluni tayima.",
        "translation": "When he returned and was finished eating, he would take that thing and go out."
    },
    "105": {
        "startTime": 894.354,
        "endTime": 901.843,
        "transcript": "Cunaw' yugnun nasvagturalallinikii teglegpek'naku.",
        "translation": "It turned out that he would show it to people without stealing it."
    },
    "106": {
        "startTime": 903.432,
        "endTime": 909.432,
        "transcript": "Tua-i pikestengaqan tun'aqluku katagaq.",
        "translation": "When he had found the owner, he would give back what was lost."
    },
    "107": {
        "startTime": 911.177,
        "endTime": 916.955,
        "transcript": "Maa-i kataganek-llu pingqerrniluteng-llu niitnaurtua.",
        "translation": "Now, I would hear that people have things that were lost."
    },
    "108": {
        "startTime": 919.032,
        "endTime": 930.587,
        "transcript": "Qanruyutelput wangkuta umyuamnun ek'artelartuq wiinga. Waten ellilriani arnaurtellriani ca umyuaqnaritulliniuq.",
        "translation": "The traditional wisdom passed down to us comes up in my mind. It turns out that we who have become old women like this remember them."
    },
    "109": {
        "startTime": 931.843,
        "endTime": 936.499,
        "transcript": "Akusrarqurallni imna pelluan.",
        "translation": "When one's mischievous phase has passed."
    },
    "110": {
        "startTime": 942.977,
        "endTime": 950.088,
        "transcript": "Yugurluut-wa imkut ak'a tamaani yuullret caperrnarqelallrullilriit.",
        "translation": "The poor peolpe back then probably lived difficult lives."
    },
    "111": {
        "startTime": 950.565,
        "endTime": 955.932,
        "transcript": "Caperrnarqeqapiggluteng takarnaqluteng-llu.",
        "translation": "They lived extremely hard lives, and we felt the need to respect them."
    },
    "112": {
        "startTime": 956.51,
        "endTime": 966.944,
        "transcript": "Niigartellerkaq-llu taumek inerquutellranek aturluni niigartellerkaq tallurnaqluni.",
        "translation": "And out of embarrassment, we would obey right away, adhere to their admonishments, and obey right away."
    },
    "113": {
        "startTime": 968.054,
        "endTime": 972.654,
        "transcript": "Tuaten ayuqsuumiitnaqluni.",
        "translation": "We wouldn't want to be bad like that."
    },
    "114": {
        "startTime": 979.943,
        "endTime": 989.498,
        "transcript": "Makut-mi mat'um nalliini, nasaurluut-wa inerquutengqelallrullilriit tan'gaurlurnek.",
        "translation": "What about now, wouldn't girls have admonishments surrounding boys?"
    },
    "115": {
        "startTime": 989.521,
        "endTime": 992.654,
        "transcript": "Yaa, inerquuterluteng.",
        "translation": "Yes, they had admonishments."
    },
    "116": {
        "startTime": 992.81,
        "endTime": 1001.01,
        "transcript": "Uinguarcetarkauniluku-llu tauna angun kenekluku arnam pikaku.",
        "translation": "And they would make that man do things only husbands do if a woman makes love to him."
    },
    "117": {
        "startTime": 1001.677,
        "endTime": 1005.477,
        "transcript": "Alingnaqluni tua-i ircaqurrlugnaqluni.",
        "translation": "It was so scary it made our hearts skip a beat."
    },
    "118": {
        "startTime": 1012.513,
        "endTime": 1030.256,
        "transcript": "Au͡gkut-llu ilait qanlartut waten: tamaani yuut caqapigtaqameng tau͡gaam niitnaularniluki makut ellmeggnek yuucimeggnek teguilriit, ellmeggnek makut ayagyuat tuqutellriit.",
        "translation": "And some of them say this: back then, they would only very rarely hear about people taking their only lives, young people killing themselves."
    },
    "119": {
        "startTime": 1030.288,
        "endTime": 1035.443,
        "transcript": "Caqapigtaqameng-gguq tau͡gaam tua-i niitnaugaqluteng.",
        "translation": "They said that they would only very rarely hear about them."
    },
    "120": {
        "startTime": 1035.454,
        "endTime": 1041.51,
        "transcript": "Maa-i-rpak-qaa tamana elpeni arenqiallugutnguuq makunun ayagyuamteńun?",
        "translation": "Is that something unfortunate to you concerning our young people?"
    },
    "121": {
        "startTime": 1043.199,
        "endTime": 1048.344,
        "transcript": "Arenqiallugutnguvkenani inerquutnguyaaqellria.",
        "translation": "It's not an accident, but something admonished against."
    },
    "122": {
        "startTime": 1048.444,
        "endTime": 1054.933,
        "transcript": "Ukaniku tau͡gaam ernermi nangneqlirmi tamakut paivtarkaugut.",
        "translation": "Someday in the last day, they will appear."
    },
    "123": {
        "startTime": 1059.598,
        "endTime": 1063.065,
        "transcript": "Tua-i atullrit.",
        "translation": "That's what they did."
    },
    "124": {
        "startTime": 1064.509,
        "endTime": 1077.432,
        "transcript": "Tuaten pisqumavkenaki. Unguvavut-llu waten anerteqlemteńi unguvavut tua-i ayimtengnaqevkenaku.",
        "translation": "They tell them not to do that. And our life as we breath, try not to destroy our life."
    },
    "125": {
        "startTime": 1077.443,
        "endTime": 1080.121,
        "transcript": "Tua-i ciumurquraasqelluta.",
        "translation": "They would tell us to keep moving forward."
    },
    "126": {
        "startTime": 1080.132,
        "endTime": 1085.388,
        "transcript": "Cakviurraarluta pellulararkaugut. Cunaw' ilumun.",
        "translation": "After struggling, they pass. It turned out to be true."
    },
    "127": {
        "startTime": 1085.399,
        "endTime": 1090.154,
        "transcript": "Maa-i wii atungekeka waten yuk'egtaunriama.",
        "translation": "I've started experiencing it now since I'm not young anymore."
    },
    "128": {
        "startTime": 1091.166,
        "endTime": 1100.055,
        "transcript": "Imutun tua-i asemtenritengnaqluku unguva.",
        "translation": "Try not to destroy your life."
    },
    "129": {
        "startTime": 1100.576,
        "endTime": 1106.41,
        "transcript": "Tau͡gaam ciumurutengnaqluku man'a elluaq.",
        "translation": "Instead, try to move forward with what is right."
    },
    "130": {
        "startTime": 1111.043,
        "endTime": 1112.954,
        "transcript": "Nuiqsugtua.",
        "translation": "I have a lot of spittle."
    },
    "131": {
        "startTime": 1118.121,
        "endTime": 1122.266,
        "transcript": "Oh, I thought I saw... do you have any questions that you want to think of?",
        "translation": "Oh, I thought I saw... do you have any questions that you want to think of?"
    },
    "132": {
        "startTime": 1123.966,
        "endTime": 1125.577,
        "transcript": "One other.",
        "translation": "One other."
    },
    "133": {
        "startTime": 1126.699,
        "endTime": 1135.699,
        "transcript": "Man'a-qaa yuut qaneryaraat iciw'... maybe I asked already.",
        "translation": "Is this Yup'ik language, you know... maybe I asked already."
    },
    "134": {
        "startTime": 1137.121,
        "endTime": 1143.021,
        "transcript": "Yuut qaneryaraat qalarcaraat-wa tua-i, wangkuk waniwa iciw' Yugcetun qalarquralriakuk?",
        "translation": "The Yup'ik language, you know how we're speaking in Yup'ik now?"
    },
    "135": {
        "startTime": 1143.443,
        "endTime": 1154.01,
        "transcript": "Man'a-qaa ayagyuanun nalluyagutesqenritan? Ciin-llu tayima nalluyagutesqenriciu qaneryararput Yugcetun?",
        "translation": "Do you want to keep the young people from forgetting it? And why don't you want our Yup'ik language to be forgotten?"
    },
    "136": {
        "startTime": 1154.399,
        "endTime": 1165.343,
        "transcript": "Ii-i, tua-i murilkelluta uitasqaitkut. Mat'um qaneryaram-llu qalarutaqamegtekut pilaqaitkut.",
        "translation": "Well, they tell us to be still and observe. And they would also say that when they talk to us about this langauge."
    },
    "137": {
        "startTime": 1168.31,
        "endTime": 1176.744,
        "transcript": "Tua-i tau͡gaam piicagturluta ikayuusqelluta Agayutmun.",
        "translation": "We must only pray for God to help us."
    },
    "138": {
        "startTime": 1181.054,
        "endTime": 1191.221,
        "transcript": "Waten ellineq tua-i imutun elli'irtun ellitulliniuq caqerciiga[nani]. Uum-wa wii tallima-ll' pikiinga.",
        "translation": "Becoming like this, people apparently become unable like this. My arm also deters me."
    },
    "139": {
        "startTime": 1193.998,
        "endTime": 1198.854,
        "transcript": "Tua-i nanikualartua.",
        "translation": "I feel helpless."
    },
    "140": {
        "startTime": 1198.866,
        "endTime": 1207.755,
        "transcript": "Ingna panika wiinga natmun ayagaqan tua-i wiinga nanikuaqapiarlua.",
        "translation": "When my daughter over there travels anywhere, I feel extremely helpless."
    },
    "141": {
        "startTime": 1211.121,
        "endTime": 1218.21,
        "transcript": "Tau͡gken nunuryugaqluku wangni qatpagalluku-ll' niicunritnilua.",
        "translation": "Yet I scold her and shout at her for not listening to me."
    },
    "142": {
        "startTime": 1222.387,
        "endTime": 1229.887,
        "transcript": "Maurlurluqa-llu qanlallruuq waten qalarutaqamia tuar qatpagaskiinga.",
        "translation": "My grandmother would also speak to me like this as if she were shouting at me."
    },
    "143": {
        "startTime": 1231.132,
        "endTime": 1239.688,
        "transcript": "Tamana-qaa camek kangingqertuq qatpagalluku ayagyuaq qalarutellni tegganrem?",
        "translation": "Is there a meaning behind an elder speaking to a young person as if shouting?"
    },
    "144": {
        "startTime": 1242.01,
        "endTime": 1247.932,
        "transcript": "Assilriamek qanelria qanra uluqsaunaku tangvaasqaat.",
        "translation": "They would tell them not to look away from the person's mouth who's speaking of good things."
    },
    "145": {
        "startTime": 1248.699,
        "endTime": 1253.31,
        "transcript": "Ircaqumun-gguq qemagartellerkaa pitekluku.",
        "translation": "They said it was so that it could be stored in the heart."
    },
    "146": {
        "startTime": 1255.633,
        "endTime": 1263.644,
        "transcript": "Tua-i ca atuqataquniu imna-llu eneqaquniu aren tua-i inerquun.",
        "translation": "If he's going to do something, he will remember that admonishment."
    },
    "147": {
        "startTime": 1266.298,
        "endTime": 1269.154,
        "transcript": "Tua-i pinriceńaraqluku.",
        "translation": "He would end up not doing it."
    },
    "148": {
        "startTime": 1273.565,
        "endTime": 1284.799,
        "transcript": "Camek-qaa piciatun qanqeryuumiituten makut ayagyuat maani Kuigpiim Kusquqviim-llu iluani niitarkaatnek?",
        "translation": "Do you want to say anything that you want the young people of the Yukon and the Kuskokwim here to hear?"
    },
    "149": {
        "startTime": 1289.01,
        "endTime": 1299.065,
        "transcript": "Aren, qessanaicaaqellria. Kalikanek-llu tangerciigatua. Iigka assiirutuk.",
        "translation": "Oh my, I am not disinclined. I can't see papers either. My eyes have gone bad."
    },
    "150": {
        "startTime": 1299.943,
        "endTime": 1305.377,
        "transcript": "Camek tangssuirutuk. Igat-llu tua-i kalikaq qaterrluni.",
        "translation": "They can't see anymore. And with writing, the paper looks white."
    },
    "151": {
        "startTime": 1311.21,
        "endTime": 1317.465,
        "transcript": "Makunek-wa tua-i qanelriit qaneryaramek atawauyaaqut.",
        "translation": "It is good that these people are speaking about traditional wisdom."
    },
    "152": {
        "startTime": 1318.976,
        "endTime": 1329.499,
        "transcript": "Niitellriani tua-i umyuaq cakneq iluteqa'artelartuq ellaicetun ayuqsugyaaqluni.",
        "translation": "It brings great sadness to mind when listening to them out of the desire to be like them."
    },
    "153": {
        "startTime": 1334.899,
        "endTime": 1341.221,
        "transcript": "Ayuqsugyaaqluni tua-i arenqiatuq.",
        "translation": "It's distressing wanting to be like that."
    }
};